// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"787ceafa","40":"0e5732ee","71":"86518b80","143":"57be87f6","804":"1190491c","943":"7bee3b7f"}[chunkId] + ".chunk.js";
};